module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "h1"
  }, [_vm._v("Foreword")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Find a comfortable chair and settle in, Cavaliers fans. Vince McKee is going to take you on a trip down memory lane in his new book, "), _c('i', [_vm._v("The Cleveland Cavaliers: A History of the Wine & Gold")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It’s all there—from the early days at the Cleveland Arena to Ted Stepien and the Teddy Bears to the 2007 NBA Finals. McKee hasn’t missed a thing. His thorough research and reporting is supplemented with lively interviews and anecdotes.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("All your favorite old stories are included, but there are some new ones, too—like the one about Michael Jordan and Craig Ehlo and his son, Austin. After reading this, you won’t be able to wait for the start of basketball season.")]), _vm._v(" "), _c('p', {
    staticClass: "right1"
  }, [_c('i', [_vm._v("—Mary Schmitt Boyer")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e80c1544","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/for1.vue
// module id = 72
// module chunks = 0